import React from "react";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

function clampPercent(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return "";
  if (n < 0) return 0;
  if (n > 100) return 100;
  return Math.round(n);
}

export default function PaymentTermsPicker({ value, onChange }) {
  const { t } = useTranslation();
  const v = value && typeof value === "object" ? value : {};
  const set = (patch) => onChange?.({ ...v, ...patch });

  const ppRaw = v.prepayPercent;
  const ppNum = (ppRaw === null || ppRaw === undefined || ppRaw === "") ? 0 : Number(ppRaw);
  const prepay = Number.isFinite(ppNum) ? clampPercent(ppNum) : 0;
  const remainder = 100 - (Number(prepay) || 0);

  return (
    <div className="space-y-3">
      {/* Способ оплаты */}
      <div>
        <div className="text-sm text-white/80 mb-2">{t("payment.method_title")}</div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-white/90">
          <label className="flex items-center gap-2 cursor-pointer select-none">
            <input
              type="checkbox"
              checked={!!v.cashTransfer}
              onChange={(e) => set({ cashTransfer: e.target.checked })}
            />
            <span>{t("payment.method.cash_transfer")}</span>
          </label>

          <label className="flex items-center gap-2 cursor-pointer select-none">
            <input
              type="checkbox"
              checked={!!v.bankNoVat}
              onChange={(e) => set({ bankNoVat: e.target.checked })}
            />
            <span>{t("payment.method.bank_no_vat")}</span>
          </label>

          <label className="flex items-center gap-2 cursor-pointer select-none">
            <input
              type="checkbox"
              checked={!!v.bankWithVat}
              onChange={(e) => set({ bankWithVat: e.target.checked })}
            />
            <span>{t("payment.method.bank_with_vat")}</span>
          </label>
        </div>
      </div>
{/* Проценты: по канону редактируем только предоплату, остаток считается автоматически */}
      <div className="rounded-xl border border-white/10 bg-slate-950/30 p-3">
        <label className="block text-sm mb-1 text-white/80">{t("payment.prepay_loading")}</label>

        <input
          type="number"
          inputMode="numeric"
          min={0}
          max={100}
          step={5}
          value={v.prepayPercent === null || v.prepayPercent === undefined ? "" : String(v.prepayPercent)}
          onChange={(e) => {
            const raw = String(e.target.value || "");
            if (raw === "") return set({ prepayPercent: "" });
            const digits = raw.replace(/\D/g, "").slice(0, 3);
            set({ prepayPercent: digits ? clampPercent(digits) : "" });
          }}
          onBlur={() => {
            const x = v.prepayPercent;
            if (x === "" || x === null || x === undefined) return;
            set({ prepayPercent: clampPercent(x) });
          }}
          className="w-full px-3 py-2 rounded-lg bg-slate-900 border border-slate-700 focus:outline-none focus:ring-2 focus:ring-sky-600 text-white"
          placeholder={t("common.example_50")}
        />

        <div className="text-sm text-white/85 mt-2">
          {t("payment.balance_unloading")}: <span className="font-semibold">{remainder}%</span>
        </div>
        <div className="text-xs text-white/60 mt-1">
          {i18next.t("paymentTerms.remainingAuto")}
        </div>
      </div>
    </div>
  );
}
